// extracted by mini-css-extract-plugin
export default {"content":"YrUGC","sportContainer":"FcM8a"};